import { Formik } from 'formik'
import * as Yup from 'yup'

import {
  Divider,
  Card,
  Grid,
  TextField,
  Container,
  CardContent,
  Dialog,
  DialogTitle,
  IconButton
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'


function ContactPersonDialog({ visible, title, okText, onSubmit, onClose, initialValues }) {
  if (initialValues == undefined) initialValues = {}

  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('Required').min(2, 'Min length is 2 character'),
    //last_name: Yup.string().required('Required').min(2, 'Min length is 2 character'),
    mobile: Yup.string().min(10, 'Min 10 digits').required('Required').max(10, 'Max 10 digits'),
    telephone: Yup.string().min(10, 'Min 10 digits'),
    email: Yup.string(),
    comments: Yup.string(),
  })

  const handleSubmit = async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
    onSubmit(values)
  }

  return (
    <>
      <Dialog
        maxWidth='xs'
        fullWidth
        open={visible}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
          {title}
          <IconButton
            component="span"
            size='small'
            sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
            onClick={onClose}
            variant="contained"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Container sx={{ marginBottom: 5 }} >
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
              status,
            }) => (

              <form onSubmit={handleSubmit}>
                <Divider my={3} />
                <Card >
                  <CardContent>
                    <Grid container spacing={5} style={{ paddingTop: 10 }}>
                      <Grid item md={6}>
                        <TextField
                          size="small"
                          name="first_name"
                          label="First Name"
                          value={values.first_name}
                          error={Boolean(touched.first_name && errors.first_name)}
                          fullWidth
                          helperText={touched.first_name && errors.first_name}
                          onBlur={handleBlur}
                          margin="dense"
                          onChange={handleChange}
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                      <Grid item md={6}>
                        <TextField
                          size="small"
                          name="last_name"
                          label="Last Name"
                          value={values.last_name}
                          error={Boolean(touched.last_name && errors.last_name)}
                          fullWidth
                          helperText={touched.last_name && errors.last_name}
                          onBlur={handleBlur}
                          margin="dense"
                          onChange={handleChange}
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={6}>
                      <Grid item md={6}>
                        <TextField
                          size="small"
                          name="mobile"
                          label="Mobile"
                          value={values.mobile}
                          error={Boolean(touched.mobile && errors.mobile)}
                          fullWidth
                          helperText={touched.mobile && errors.mobile}
                          onBlur={handleBlur}
                          margin="dense"
                          onChange={handleChange}
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                      <Grid item md={6}>
                        <TextField
                          size="small"
                          name="email"
                          label="email"
                          value={values.email}
                          error={Boolean(touched.email && errors.email)}
                          fullWidth
                          helperText={touched.email && errors.email}
                          onBlur={handleBlur}
                          margin="dense"
                          type="email"
                          onChange={handleChange}
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={6}>
                      <Grid item md={6}>
                        <TextField
                          size="small"
                          name="telephone"
                          label="Telephone"
                          value={values.telephone}
                          error={Boolean(touched.telephone && errors.telephone)}
                          fullWidth
                          helperText={touched.telephone && errors.telephone}
                          onBlur={handleBlur}
                          margin="dense"
                          onChange={handleChange}
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                      <Grid item md={6}>
                        <TextField
                          size="small"
                          name="comments"
                          label="Comments"
                          value={values.comments}
                          error={Boolean(touched.comments && errors.comments)}
                          fullWidth
                          helperText={touched.comments && errors.comments}
                          onBlur={handleBlur}
                          margin="dense"
                          onChange={handleChange}
                          variant="outlined"
                          multiline
                          maxRows={4}
                          my={2}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Grid container justifyContent="flex-end">
                  <Grid item  >
                    <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                      {okText}
                    </ActionButton>
                  </Grid>
                </Grid>
              </form>

            )}
          </Formik>
        </Container>
      </Dialog>
    </>
  )
}

export default ContactPersonDialog
